import { render, staticRenderFns } from "./Sendcloud.vue?vue&type=template&id=7f27cd8c&scoped=true"
import script from "./Sendcloud.vue?vue&type=script&lang=ts"
export * from "./Sendcloud.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f27cd8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f27cd8c')) {
      api.createRecord('7f27cd8c', component.options)
    } else {
      api.reload('7f27cd8c', component.options)
    }
    module.hot.accept("./Sendcloud.vue?vue&type=template&id=7f27cd8c&scoped=true", function () {
      api.rerender('7f27cd8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/plugins/Sendcloud.vue"
export default component.exports